<template>
  <Popover ref="op" class="tile-metrics" appendTo="self">
    <slot name="content"></slot>
  </Popover>

  <button @click.prevent="toggle">
    <i class="fa far fa-chevron-down"></i>
  </button>
</template>

<script setup>
  import { ref } from "vue";
  import Popover from 'primevue/popover';

  const op = ref();

  const toggle = (event) => {
    op.value.toggle(event);
  }
</script>
